"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgCloneBonusLocaleCtl = /** @class */ (function (_super) {
    __extends(DlgCloneBonusLocaleCtl, _super);
    function DlgCloneBonusLocaleCtl() {
        return _super.call(this, true) || this;
    }
    DlgCloneBonusLocaleCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            currency_id: 0,
            currency_title: "",
            currenciesAvail: [],
            language_id: 0,
            language_title: "",
            languagesAvail: [],
            onNo: null
        };
    };
    DlgCloneBonusLocaleCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgCloneBonusLocaleCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgCloneBonusLocaleCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgCloneBonusLocaleCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    DlgCloneBonusLocaleCtl.prototype.SetCurrenciesAvail = function (currencies, forceUpdate) {
        this.DATA.currenciesAvail = currencies;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetCurrenciesAvail = function () {
        return this.DATA.currenciesAvail;
    };
    DlgCloneBonusLocaleCtl.prototype.SetCurrency = function (currencyId, currencyTitle, forceUpdate) {
        this.DATA.currency_id = currencyId;
        this.DATA.currency_title = currencyTitle;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetCurrencyId = function () {
        return this.DATA.currency_id;
    };
    DlgCloneBonusLocaleCtl.prototype.GetCurrencyTitle = function () {
        return this.DATA.currency_title;
    };
    DlgCloneBonusLocaleCtl.prototype.SetLanguagesAvail = function (languages, forceUpdate) {
        this.DATA.languagesAvail = languages;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetLanguagesAvail = function () {
        return this.DATA.languagesAvail;
    };
    DlgCloneBonusLocaleCtl.prototype.SetLanguage = function (languageId, languageTitle, forceUpdate) {
        this.DATA.language_id = languageId;
        this.DATA.language_title = languageTitle;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgCloneBonusLocaleCtl.prototype.GetLanguageId = function () {
        return this.DATA.language_id;
    };
    DlgCloneBonusLocaleCtl.prototype.GetLanguageTitle = function () {
        return this.DATA.language_title;
    };
    return DlgCloneBonusLocaleCtl;
}(BaseController_1.BaseController));
exports.DlgCloneBonusLocaleCtl = DlgCloneBonusLocaleCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgCloneBonusLocaleCtl.ts
// module id = 919
// module chunks = 0